(function () {
    'use strict';

    angular
        .module('cacmDataPointModule')
        .directive('cacmDataPoint', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {
                    $scope.isExpanded = false;

                    if ($scope.boxContext && $scope.boxContext.startExpanded) {
                        $scope.isExpanded = $scope.boxContext.startExpanded;
                    }

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/cacm/datapoint/cacmDataPoint.[Template].tpl.html';
                    $controller('BoxTmplController', { $scope: $scope });


                    // Prepare JSON content
                    var parsedJson = $scope.boxModel.JsonContent ? JSON.parse($scope.boxModel.JsonContent) : null;

                    // Group HBEFORE/HAFTER
                    var beforeAfterKey = null,
                        beforeAfterValue = null;
                    _.map(parsedJson, function (value, key, obj) {
                        var idx_HAFTER = key.indexOf('_HAFTER'),
                            idx_HBEFORE = key.indexOf('_HBEFORE');

                        if (idx_HAFTER > 0) {
                            beforeAfterKey = key.substring(0, idx_HAFTER);
                            beforeAfterValue = value;
                            delete obj[key];
                            obj[beforeAfterKey] = '<span class="value-changed-after">' + value + '</span>';
                        } else if (idx_HBEFORE > 0) {
                            var beforeKey = key.substring(0, idx_HBEFORE);
                            if (beforeAfterKey !== beforeKey) {
                                // No matching HAFTER
                                delete obj[key];
                                obj[beforeKey] = '<span class="value-changed-before">' + value + '</span>';
                            } else {
                                delete obj[beforeAfterKey + '_HAFTER'];
                                delete obj[key];
                                obj[beforeKey] = '<span class="value-changed-before">' + beforeAfterValue + '</span>' +
                                    ' &#8594; ' +
                                    '<span class="value-changed-after">' + value + '</span>';
                            }
                        }
                    });

                    $scope.jsonContent = parsedJson;

                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();